<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
const props = defineProps({ dateUnassign: { type: String, required: true } });
const now = ref(Date.now());
let interval = null;
const target = computed(() => {
  if (!props.dateUnassign) return null;
  const d = new Date(props.dateUnassign);
  return isNaN(d) ? null : d.getTime();
});
const remaining = computed(() => {
  if (!target.value) return null;
  const diff = target.value - now.value;
  return diff > 0 ? diff : 0;
});
const formatted = computed(() => {
  if (!remaining.value || remaining.value <= 0) return null;
  let totalSeconds = Math.floor(remaining.value / 1000);
  const days = Math.floor(totalSeconds / 86400);
  totalSeconds %= 86400;
  const hours = Math.floor(totalSeconds / 3600);
  totalSeconds %= 3600;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  let str = '';
  if (days > 0) str += days + 'd ';
  if (hours > 0 || days > 0) str += hours.toString().padStart(2, '0') + ':';
  str += minutes.toString().padStart(2, '0') + ':';
  str += seconds.toString().padStart(2, '0');
  return str;
});
onMounted(() => {
  interval = setInterval(() => {
    now.value = Date.now();
  }, 1000);
});
onUnmounted(() => {
  if (interval) clearInterval(interval);
});
</script>
<template>
  <span v-if="formatted" class="countdown-badge">{{ formatted }}</span>
</template>
<style scoped>
.countdown-badge {
  display: inline-block;
  background: linear-gradient(90deg, #ff9800 0%, #ffc107 100%);
  color: #222;
  font-weight: bold;
  border-radius: 8px;
  padding: 0.25em 0.75em;
  font-size: 0.95em;
  margin-inline: auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  letter-spacing: 0.03em;
  animation: pulse 1.5s infinite;
  width: 100%;
  text-align: center;
}
@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(255,193,7,0.4); }
  70% { box-shadow: 0 0 0 8px rgba(255,193,7,0); }
  100% { box-shadow: 0 0 0 0 rgba(255,193,7,0); }
}
</style>
